import React from 'react';
import {Route, Switch, useLocation, Redirect} from 'react-router-dom';
import {MENU_PATHS, isAuthenticated} from "../misc/Shared";
import VeteransConfirmationPage from '../pages/VeteransConfirmationPage';
import PageLogout from "../pages/PageLogout"
import PageLogin from '../pages/PageLogin';



function RequireAuth({ children }) { 
	const location = useLocation();	
	return isAuthenticated() ? children : <Redirect to='/'/>;
}

class AppRoutes extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<Switch>
				<Route path={MENU_PATHS.VETERANCONFIRMATIONPAGE} render={props => <VeteransConfirmationPage/>}/>
				<Route path={MENU_PATHS.LOGIN} render={props => <PageLogin/>}/> 
				<Route path={MENU_PATHS.LOGOUT} render={props => <PageLogout/>}/>
			</Switch>
			
		);
	}
}

export default AppRoutes;